'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScriptIcon = function ScriptIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 16 16' }, props),
        _react2.default.createElement('path', { d: 'M0 7c.617 0 1.197-.123 1.5-.5.303-.377.5-1.051.5-2V3c0-1.078.407-1.752.899-2.255C3.392.242 4.186 0 5.281 0H6v2l-.068.002c-.751 0-1.208.097-1.373.289s-.246.729-.246 1.611c0 1.127-.083 1.98-.25 2.558C3.896 7.037 3.64 7.548 3 8c.64.447.896.965 1.063 1.543.167.578.25 1.432.25 2.561 0 .884.082 1.421.246 1.614.164.192.622.289 1.373.289L6 14v2h-.719c-1.096 0-1.89-.233-2.382-.736S2 14.078 2 13v-1.5c0-.955-.197-1.626-.5-2C1.197 9.126.617 9.006 0 9V7zm16 2c-.617.006-1.199.126-1.5.5-.3.374-.5 1.045-.5 2V13c0 1.078-.312 1.761-.805 2.264S11.906 16 10.804 16H10v-2l.154.007c.756 0 1.217-.097 1.381-.289.164-.193.246-.73.246-1.614 0-1.129.083-1.982.25-2.561S12.366 8.447 13 8c-.634-.452-.802-.963-.969-1.541s-.25-1.43-.25-2.558c0-.882-.082-1.419-.246-1.611s-.625-.288-1.381-.288L10 2V0h.805c1.102 0 1.898.242 2.391.745C13.688 1.248 14 1.922 14 3v1.5c0 .949.2 1.623.5 2 .301.377.883.5 1.5.5v2z' })
    );
};

exports.default = ScriptIcon;